import PropTypes from 'prop-types';
import React from 'react';

import { colors } from '../../../common/styles/style-constants';

const HealthyGums = ({ color }) => (
  <svg width="15" height="15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.817 15H6.183a1.19 1.19 0 0 1-1.189-1.19v-3.804H1.19A1.19 1.19 0 0 1 0 8.816V6.184c0-.655.534-1.189 1.19-1.189h3.804V1.19C4.994.534 5.528 0 6.184 0h2.633c.655 0 1.189.534 1.189 1.19v3.804h3.805c.655 0 1.189.534 1.189 1.19v2.633a1.19 1.19 0 0 1-1.19 1.189h-3.804v3.805A1.19 1.19 0 0 1 8.816 15zM1.189 6.013a.17.17 0 0 0-.17.17v2.634c0 .094.076.17.17.17h4.825v4.824c0 .094.076.17.17.17h2.633a.17.17 0 0 0 .17-.17V8.986h4.824a.17.17 0 0 0 .17-.17V6.183a.17.17 0 0 0-.17-.17H8.987V1.19a.17.17 0 0 0-.17-.17H6.183a.17.17 0 0 0-.17.17v4.824H1.19z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

HealthyGums.defaultProps = {
  color: colors.blue,
};

HealthyGums.propTypes = {
  color: PropTypes.string,
};

export default HealthyGums;
